module.exports = __webpack_public_path__ + "static/media/sitemapicon.09e65027.svg";